import { render, staticRenderFns } from "./AddVideoChick.vue?vue&type=template&id=f55b7f6a"
import script from "./AddVideoChick.vue?vue&type=script&lang=js"
export * from "./AddVideoChick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports